// extracted by mini-css-extract-plugin
export var cta = "ModalContent-module--cta--PaFjp";
export var modalContainer = "ModalContent-module--modal-container--2H-iR";
export var modalClose = "ModalContent-module--modal-close--1mJ-T";
export var modalContentCopy = "ModalContent-module--modal-content-copy--Fb6Rt";
export var modalAuthorTitle = "ModalContent-module--modal-author-title--3Fz5B";
export var author = "ModalContent-module--author--3eKF5";
export var labelSmall = "ModalContent-module--label-small--3goLO";
export var content = "ModalContent-module--content--2m8nO";
export var modalLoadBtn = "ModalContent-module--modalLoadBtn--4VQb9";